import { useMemo } from 'react';
import DefaultIcon2 from '$components/DefaultIcon2/DefaultIcon2';
import capitalizedName from '$utils/capitalizedName';
import computeYearsOfExperience from '$utils/computeYearsOfExperience';
import { countriesCodes } from '$constants/countriesCodes';
import { SIMERA_FEE } from '$constants/SimeraOperations';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import { CandidateData } from '$types/candidates';

const SPKShowcaseCandidateInfo = ({
  candidate,
}: {
  candidate: CandidateData;
}) => {
  const { currency, currencyCode, usdToCurrencyConverter } = useAppSelector(
    (state) => state.brand
  );

  const yearsOfExperience = useMemo(() => {
    return computeYearsOfExperience(candidate.CandidateWorkExperience);
  }, [candidate.CandidateWorkExperience]);

  const countryEmoji = useMemo(() => {
    return countriesCodes.find(
      (singleCountry) =>
        singleCountry.name.toLowerCase() ===
        candidate?.ResidenceCountry?.toLowerCase()
    )?.code;
  }, [candidate?.ResidenceCountry]);

  return (
    <div className="flex flex-row gap-4 items-center mb-4">
      <div className="w-10 min-w-10">
        <DefaultIcon2
          firstName={candidate.User?.FirstName}
          lastName={candidate.User?.LastName}
          fontSize="text-xl"
          hideBorder
          picture={candidate?.User?.ProfilePicture?.Url}
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center gap-2">
          <span className="font-bold text-base">
            {`${capitalizedName(candidate.User?.FirstName)} ${capitalizedName(
              candidate.User?.LastName
            )}`}
          </span>
          {candidate.ResidenceCountry && (
            <span className="text-nowrap font-light text-xs border border-neutral-200 text-neutral-600 rounded-md px-2 py-1 flex gap-2 items-center self-center mr-2">
              <span className={`fi fi-${countryEmoji?.toLowerCase()}`} />
              {candidate.ResidenceCountry}
            </span>
          )}
        </div>
        <div className="flex flex-row items-center gap-2 text-sm text-spk-highContrast divide-x divide-spk-mediumContrast *:px-2 -mx-2">
          {candidate?.CandidateWorkExperience?.[0]?.JobTitle && (
            <span>{candidate?.CandidateWorkExperience?.[0]?.JobTitle}</span>
          )}
          <span>
            {currency}
            {usdToCurrencyConverter(
              (candidate?.CandidateJobInterest?.SalaryLowerBound || 0) +
                SIMERA_FEE
            )}
            /m {currencyCode}
          </span>
          <span>{yearsOfExperience}+ yrs</span>
        </div>
      </div>
    </div>
  );
};

export default SPKShowcaseCandidateInfo;
